unit View.Cst_Pis.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCst_PisEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbcst_pis_id: TLabel;
    edcst_pis_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCst_PisGet: TXDataWebClient;
    XDataClientCst_PisDelete: TXDataWebClient;
    Cst_PisDataset: TXDataWebDataSet;
    Cst_PisDatasetcst_pis_id: TStringField;
    Cst_PisDatasetnome: TStringField;
    Cst_PisDatasetexcluido: TBooleanField;
    Cst_PisDatasetinclusao: TDateTimeField;
    Cst_PisDatasetalteracao: TDateTimeField;
    Cst_PisDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCst_PisGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCst_PisDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCst_PisDeleteError(Error: TXDataClientError);
    procedure Cst_PisDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCst_PisEdit: TFViewCst_PisEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCst_PisEdit }

procedure TFViewCst_PisEdit.btSaveClick(Sender: TObject);
begin
  if Cst_PisDataset.State in dsEditModes then
  begin
        Cst_PisDataset.Post;
    Cst_PisDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCst_PisEdit.btDeleteClick(Sender: TObject);
begin
  if Cst_PisDataset.State in dsEditModes then
    Cst_PisDataset.Post;
  XDataClientCst_PisDelete.Delete(Cst_PisDataset.EntitySetName,
    TJSObject(Cst_PisDataset.CurrentData));
end;


class function TFViewCst_PisEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCst_PisEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCst_PisEdit.InsertEntity;
begin
  Cst_PisDataset.Close;
  Cst_PisDataset.SetJsonData('{}');
  Cst_PisDataset.Open;
  Cst_PisDataset.Insert;
end;

class function TFViewCst_PisEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCst_PisEdit(AForm).FInserting := AInserting;
    TFViewCst_PisEdit(AForm).FId := AId;
    TFViewCst_PisEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCst_PisEdit(AForm).InsertEntity
    else
      TFViewCst_PisEdit(AForm).LoadEntity;
    TFViewCst_PisEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCst_PisEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCst_PisEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Cst_PisDataset.Connection.Model.DefaultSchema.FindEntityType(
      Cst_PisDataset.EntitySetName
    )
  );
  XDataClientCst_PisGet.Get(Cst_PisDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCst_PisEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCst_PisEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCst_PisEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCst_PisEdit.XDataClientCst_PisGetLoad(Response: TXDataClientResponse);
begin
  Cst_PisDataset.Close;
  Cst_PisDataset.SetJsonData(Response.Result);
  Cst_PisDataset.Open;
  
  Cst_PisDataset.Edit;  
end;

procedure TFViewCst_PisEdit.XDataClientCst_PisDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCst_PisEdit.XDataClientCst_PisDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCst_PisEdit.Cst_PisDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCst_PisEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCst_PisEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.cst_pis.form.message');
  lbMessage := TLabel.Create('view.cst_pis.form.message.label');
  btCloseMessage := TButton.Create('view.cst_pis.form.message.button');
  btCancel := TButton.Create('view.cst_pis.form.btBack');
  btSave := TButton.Create('view.cst_pis.form.btSave');
  btDelete := TButton.Create('view.cst_pis.form.btDelete');
  lbcst_pis_id := TLabel.Create('view.cst_pis.form.lbcst_pis_id');
  edcst_pis_id := TDBEdit.Create('view.cst_pis.form.edcst_pis_id');
  lbnome := TLabel.Create('view.cst_pis.form.lbnome');
  ednome := TDBEdit.Create('view.cst_pis.form.ednome');
  lbexcluido := TLabel.Create('view.cst_pis.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.cst_pis.form.edexcluido');
  lbinclusao := TLabel.Create('view.cst_pis.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.cst_pis.form.edinclusao');
  lbalteracao := TLabel.Create('view.cst_pis.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.cst_pis.form.edalteracao');
  lbexclusao := TLabel.Create('view.cst_pis.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.cst_pis.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Cst_PisDataset := TXDataWebDataSet.Create(Self);
  Cst_PisDatasetcst_pis_id := TStringField.Create(Self);
  Cst_PisDatasetnome := TStringField.Create(Self);
  Cst_PisDatasetexcluido := TBooleanField.Create(Self);
  Cst_PisDatasetinclusao := TDateTimeField.Create(Self);
  Cst_PisDatasetalteracao := TDateTimeField.Create(Self);
  Cst_PisDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCst_PisGet := TXDataWebClient.Create(Self);
  XDataClientCst_PisDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbcst_pis_id.BeforeLoadDFMValues;
  edcst_pis_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Cst_PisDataset.BeforeLoadDFMValues;
  Cst_PisDatasetcst_pis_id.BeforeLoadDFMValues;
  Cst_PisDatasetnome.BeforeLoadDFMValues;
  Cst_PisDatasetexcluido.BeforeLoadDFMValues;
  Cst_PisDatasetinclusao.BeforeLoadDFMValues;
  Cst_PisDatasetalteracao.BeforeLoadDFMValues;
  Cst_PisDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCst_PisGet.BeforeLoadDFMValues;
  XDataClientCst_PisDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCst_PisEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbcst_pis_id.SetParentComponent(Self);
    lbcst_pis_id.Name := 'lbcst_pis_id';
    lbcst_pis_id.Left := 24;
    lbcst_pis_id.Top := 192;
    lbcst_pis_id.Width := 14;
    lbcst_pis_id.Height := 13;
    lbcst_pis_id.Caption := 'cst_pis_id:';
    lbcst_pis_id.Transparent := True;
    edcst_pis_id.SetParentComponent(Self);
    edcst_pis_id.Name := 'edcst_pis_id';
    edcst_pis_id.Left := 221;
    edcst_pis_id.Top := 189;
    edcst_pis_id.Width := 200;
    edcst_pis_id.Height := 21;
    edcst_pis_id.Enabled := True;
    edcst_pis_id.TabOrder := 6;
    edcst_pis_id.Text := 'edcst_pis_id';
    edcst_pis_id.DataField := 'cst_pis_id';
    edcst_pis_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Cst_PisDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Cst_PisDataset.SetParentComponent(Self);
    Cst_PisDataset.Name := 'Cst_PisDataset';
    Cst_PisDataset.AfterApplyUpdates := Cst_PisDatasetAfterApplyUpdates;
    Cst_PisDataset.EntitySetName := 'Cst_Pis';
    Cst_PisDataset.Connection := DMConnection.ApiConnection;
    Cst_PisDataset.Left := 176;
    Cst_PisDataset.Top := 8;
    Cst_PisDatasetcst_pis_id.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetcst_pis_id.Name := 'Cst_PisDatasetcst_pis_id';
    Cst_PisDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Cst_PisDatasetcst_pis_id.Required := True;
    Cst_PisDatasetcst_pis_id.Size := 255;
    Cst_PisDatasetnome.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetnome.Name := 'Cst_PisDatasetnome';
    Cst_PisDatasetnome.FieldName := 'nome';
    Cst_PisDatasetnome.Required := True;
    Cst_PisDatasetnome.Size := 255;
    Cst_PisDatasetexcluido.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetexcluido.Name := 'Cst_PisDatasetexcluido';
    Cst_PisDatasetexcluido.FieldName := 'excluido';
    Cst_PisDatasetexcluido.Required := False;
    Cst_PisDatasetinclusao.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetinclusao.Name := 'Cst_PisDatasetinclusao';
    Cst_PisDatasetinclusao.FieldName := 'inclusao';
    Cst_PisDatasetinclusao.Required := False;
    Cst_PisDatasetalteracao.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetalteracao.Name := 'Cst_PisDatasetalteracao';
    Cst_PisDatasetalteracao.FieldName := 'alteracao';
    Cst_PisDatasetalteracao.Required := False;
    Cst_PisDatasetexclusao.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetexclusao.Name := 'Cst_PisDatasetexclusao';
    Cst_PisDatasetexclusao.FieldName := 'exclusao';
    Cst_PisDatasetexclusao.Required := False;
    XDataClientCst_PisGet.SetParentComponent(Self);
    XDataClientCst_PisGet.Name := 'XDataClientCst_PisGet';
    XDataClientCst_PisGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCst_PisGet, Self, 'OnLoad', 'XDataClientCst_PisGetLoad');
    XDataClientCst_PisGet.Left := 64;
    XDataClientCst_PisGet.Top := 8;
    XDataClientCst_PisDelete.SetParentComponent(Self);
    XDataClientCst_PisDelete.Name := 'XDataClientCst_PisDelete';
    XDataClientCst_PisDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCst_PisDelete, Self, 'OnLoad', 'XDataClientCst_PisDeleteLoad');
    SetEvent(XDataClientCst_PisDelete, Self, 'OnError', 'XDataClientCst_PisDeleteError');
    XDataClientCst_PisDelete.Left := 64;
    XDataClientCst_PisDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbcst_pis_id.AfterLoadDFMValues;
    edcst_pis_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Cst_PisDataset.AfterLoadDFMValues;
    Cst_PisDatasetcst_pis_id.AfterLoadDFMValues;
    Cst_PisDatasetnome.AfterLoadDFMValues;
    Cst_PisDatasetexcluido.AfterLoadDFMValues;
    Cst_PisDatasetinclusao.AfterLoadDFMValues;
    Cst_PisDatasetalteracao.AfterLoadDFMValues;
    Cst_PisDatasetexclusao.AfterLoadDFMValues;
    XDataClientCst_PisGet.AfterLoadDFMValues;
    XDataClientCst_PisDelete.AfterLoadDFMValues;
  end;
end;

end.
